

import { CF2Component, registerComponent } from 'javascript/lander/runtime'

export default class ModalV1 extends CF2Component {

constructor(el, runtimeSel) {
super(el, runtimeSel)
}

mount(el) {
    const node = this
    this.onClose = this.onClose ?? function() { }

    this.close = this.close ?? function () {
      if (node.element) {
        document.documentElement.classList.remove('hide-page-scroll')
        node.element.style.display = 'none'
        node.onClose()
      };
    }

    this.setupModalClose = function () {
      $(node.element).on('click', function (e) {
        if (e.target !== e.currentTarget) return;
        if (window.getSelection().type === 'Range') return
        node.close()
      });
      $(node.element).on('click', '.elModalClose', function () {
        node.close()
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === "Escape") {
          node.close()
        }
      });
    }

    this.setupModalClose()
  }



}

registerComponent('Modal/V1', ModalV1)
window["ModalV1"] = ModalV1

